<style scoped>
    @import url("../../styles/lora2/geralLora.scss");
</style>

<template>
    <div class="box_geralLora">

        <!-- Se estiver travando a entrada, colocar um loading com flag condicionado a 1a req rcv -->

        <div class="titGeral">
            <v-icon :style="{'color':'rgb(31,122,177)'}">mdi-signal</v-icon>
            <span class="ml-2">Mapeamento sinal LoRaWAN</span>
        </div>

        <div class="painelGeral">

            <!--<div class="progress_bar" v-if="flagLoadingSinal">

                <span class="mb-2" :style="{'font-size':'0.7rem'}">Buscando suas informações</span>

                <v-progress-circular
                :size="70"
                :width="7"
                color="black"
                indeterminate
                ></v-progress-circular>

            </div>-->

            <!-- LOADING MAPA -->
            <div v-if="flagLoadingSinal" class="mb-16"
            :style="{'display':'flex','width':'100%','align-items':'center','justify-content':'center'}">
                <v-progress-circular 
                color="black"
                size="160"
                indeterminate
                :style="{'display':'flex','align-items':'center','justify-content':'center'}"
                >
                    <!--<span :style="{'font-size':'0.7rem','width':'60%'}">
                        Aguarde <br>
                        enquanto montamos <br>
                        o seu mapa
                    </span>-->
                    <div :style="{
                        'display':'flex', 'flex-direction':'column',
                        'font-size':'0.7rem',
                        'align-items':'center','justify-content':'center'
                        }"
                    >
                        <span>Aguarde</span>
                        <span>enquanto</span>
                        <span>montamos</span>
                        <span>o seu mapa</span>
                    </div>
                </v-progress-circular>
            </div>

            <PontosPub v-if="!flagLoadingSinal" :listaCoords="this.listaCoords" />

            <!-- "gambiarra"  de sobreposição de elementos na página LARGE -->
            <div class="segunda_linha hidden-sm-and-down mb-16">
                <div class="sobreposta"></div>
            </div>

            <!-- "gambiarra"  de sobreposição de elementos na página SMALL -->
            <div class="segunda_linha_small hidden-md-and-up mb-16">
                <div class="sobreposta_small"></div>
            </div>
        </div>

    </div>
</template>

<script>
import axios from 'axios'
import PontosPub from './PontosPub'

export default {

    components:{PontosPub},

    data() {
        return {
            //
            flagLoadingSinal:true,
            listaCoords:[],
        }
    },

    methods:{
        init() {
            // -- from local storage
            var contentUser = JSON.parse(localStorage.getItem('contentUser'))
            const emailCliente = contentUser['email']

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }

            let self = this
            
            let params = { 
                'marcador': self.$store.state.markPriv, 
                'cliente':emailCliente
            }

            let url = self.$store.state.pathAxiosBASE + '/mappointslorawanx' // concat

            axios.post(url, params, {headers}).then(function (res) {

                //console.log(res.data.result)
                self.listaCoords = res.data.result // liP
                if (self.listaCoords.length > 0) { 
                    console.log('map init')
                    self.flagLoadingSinal = false // lista map sinal ok
                }
                else { console.log('map failed') }
            })
        },
    },

    created() {
        window.scrollTo(0,0)
        this.init()

        // -- req mapa de pontos.
        /*
        var self = this
        
        axios.get(self.$store.state.pathAxiosGetLora).then(function (res) {
            //console.log('RCV FROM testerConV4')
            //console.log(res.data.result)
            self.listaCoords = res.data.result //.liP
            //self.listaGw = res.data.result.liGw
            //self.listaCirc = res.data.result.liCirc
            
            if (self.listaCoords.length > 0) { self.flagLoadingSinal = false } //lista map sinal ok
            //self.flagLoadingSinal = true // tmp manutenção fev25
        })
        */
    }
}
</script>